if (!String.prototype.hasOwnProperty('escapeChars')) {
  String.prototype.escapeChars = function() {
    return this.replace(/[\$\[\+\*\|\(\)\^\?\.\\\/]/g, '\\$&');
  };
}
if (!String.prototype.hasOwnProperty('escapeSearch')) {
  String.prototype.escapeSearch = function() {
    return this.replace(/[\$\[\+\*\|\^\?]/g, '');
  };
}